import{toDate as t}from"./toDate.js";function e(e,o){const r=t(e),n=t(o);return 12*(r.getFullYear()-n.getFullYear())+(r.getMonth()-n.getMonth())}export{e as default,e as differenceInCalendarMonths};
//# sourceMappingURL=differenceInCalendarMonths.js.map
